var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RadioGroup", {
        attrs: { options: _vm.yesNoOptions },
        on: { change: _vm.emitChangeEvent },
        model: {
          value: _vm.yesNo,
          callback: function($$v) {
            _vm.yesNo = $$v
          },
          expression: "yesNo"
        }
      }),
      _vm._v(" "),
      _vm.sleepoverEligible
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("Messages", {
                attrs: {
                  messages: ["Wieviele Übernachtungen wären für dich OK?"]
                }
              }),
              _vm._v(" "),
              _c("SelectInline", {
                attrs: {
                  "characteristic-items": _vm.meta.externalSleepover,
                  "nothing-allowed": {
                    text: "egal"
                  }
                },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.sleepover,
                  callback: function($$v) {
                    _vm.sleepover = $$v
                  },
                  expression: "sleepover"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }